<template>
  <v-card class="transparent ma-0" height="100%" width="100%">
    <v-card class="_light_grey" width="100%" :height="height">
      <v-row class="px-2 customStyle">
        <template v-for="item in selectType">
          <v-col cols="12" sm="2" :key="item">
            <v-select
              class="pa-1"
              :items="selectItems(item)"
              :prefix="`${$t(item)}：`"
              :menu-props="{ bottom: true, offsetY: true }"
              dense
              v-model="selectValue[item]"
              @input="selectFilter()"
              @change="operationLog(item, selectValue[item])"
              :label="$t(item)"
            >
            </v-select>
          </v-col>
        </template>
        <v-spacer />
        <v-col cols="12" sm="3">
          <v-text-field
            class="pa-1"
            dense
            v-model="searchText"
            :label="$t('search')"
            @keyup.enter="searchKeyUp()"
            @change="operationLog('search', searchText)"
          >
            <v-icon slot="prepend">mdi-magnify</v-icon>
          </v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-container fluid class="pa-0">
      <router-view />
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Db from '@/api/awsDb';
import CommVar from '@/method/commVar';

export default {
  name: 'Layout',
  components: {},
  data: () => ({
    selectType: ['industrys', 'publishers', 'types', 'runtimeEnvironment'],
    selectValue: {
      industrys: 'All',
      publishers: 'All',
      types: 'All',
      runtimeEnvironment: 'All',
    },
    searchText: '',
    customPage: 0,
  }),
  computed: {
    ...mapState('dbTable', ['filterList', 'filterSubject', 'filterParams', 'customList']),
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    ...mapGetters('dbTable', ['categoryList', 'productList', 'generalIndustryId']),
    ...mapGetters('locale', ['locale']),
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'auto';
        default:
        case 'sm':
          return 60;
      }
    },
  },
  mounted() {
    this.selectValue = this.filterParams;
    this.$root.$on('clearFilter', () => {
      this.searchText = '';
      Object.keys(this.selectValue).forEach((key) => {
        this.selectValue[key] = 'All';
      });
    });
  },
  updated() {
    this.routerQuery();
  },
  methods: {
    industrysFilter(key, product) {
      return key === 'industrys' && product[key] === this.generalIndustryId(this.locale);
    },
    selectFilter() {
      if (!this.productList.length) return;
      const filterObj = {};
      Object.keys(this.selectValue).forEach((key) => {
        if (this.selectValue[key] !== 'All') {
          filterObj[key] = this.selectValue[key];
          if (key === 'publishers') {
            const custom = this.customList.find((x) => x.id === this.selectValue.publishers);
            this.customPage = custom === undefined ? 0 : custom.type;
          }
        } else if (key === 'publishers') {
          this.customPage = 0;
        }
      });
      let temp = [...this.productList];
      let queryStr = '';
      Object.keys(filterObj).forEach((key) => {
        temp = temp.filter((x) => x[key] && (x[key] === filterObj[key] || this.industrysFilter(key, x)) && x[key] !== 'All');
        queryStr += `${key}=${filterObj[key]}&`;
      });
      this.$store.commit('dbTable/setFilterList', temp);
      this.$store.commit('dbTable/setFilterSubject', this.$t('filter'));
      this.searchText = '';
      if (this.customPage !== 0) {
        this.$store.commit('dbTable/setFilterSubject', this.selectValue.publishers);
        this.routerPush(`custom${this.customPage}`);
      } else {
        this.routerPush('filterList');
      }
      window.history.replaceState(null, null, `#/?${queryStr.slice(0, -1)}`);
    },
    selectItems(item) {
      if (!this.categoryList.length) return [];
      let temp = this.categoryList.filter((x) => x.category === item);
      temp = temp.map((x) => ({ text: x.name, value: x.id, sortNo: x.seqno }));
      let ary = [];
      switch (item) {
        case 'publishers':
          if (!this.productList.length) break;
          temp.forEach((x) => {
            const temp2 = this.productList.filter((y) => y.publishers === x.value);
            if (temp2.length > 0) ary.push(x);
          });
          break;
        default:
          ary = [...temp];
          break;
      }
      ary.sort((a, b) => a.sortNo - b.sortNo);
      ary.unshift({ text: 'All', value: 'All', sortNo: null });
      return ary;
    },
    searchKeyUp() {
      if (!this.productList.length) return;
      const list = this.productList.filter((obj) => JSON.stringify(obj).toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1);
      this.$store.commit('dbTable/setFilterList', list);
      this.$store.commit('dbTable/setFilterSubject', this.$t('search'));
      Object.keys(this.selectValue).forEach((key) => {
        this.selectValue[key] = 'All';
      });
      this.routerPush('filterList');
    },
    routerQuery() {
      if (!Object.keys(this.$route.query).length || 'locale' in this.$route.query || 'deviceId' in this.$route.query) return;
      Object.keys(this.$route.query).forEach((key) => {
        switch (key) {
          case 'industrys':
          case 'publishers':
          case 'types':
          case 'runtimeEnvironment':
            this.selectValue[key] = this.$route.query[key];
            break;
          default:
            break;
        }
      });
      if (Object.keys(this.selectValue).length) this.selectFilter();
    },
    routerPush(name) {
      if (this.$route.name === name) return;
      this.$router.push({ name });
    },
    operationLog(item, value) {
      // if (!this.isSignIn) return;
      if (value === 'All') return;
      const params = {};
      params.id = CommVar.randomId();
      params.createTime = new Date().getTime();
      params.email = this.isSignIn ? this.userAttribute.email : '';
      params.log = { [item]: value };
      params.sessionId = window.sessionStorage.getItem('id');
      Db.create('operation', params);
    },
  },
};
</script>

<style>
.customStyle .v-label {
  font-size: 0rem;
}
</style>
